import React, { useMemo, useEffect } from 'react'
import { IWithRequireAuthenticationProps } from './Interfaces'
import AuthenticationControllerService from 'smart-components/authentication-controller/Service'
import { Vault } from 'lib'
import { navigate } from '@reach/router'
import { AuthenticationMonitor } from 'smart-components'

function withRequireAuthentication<P extends object>(Component: React.ComponentType<P>) {
  return (props: P & IWithRequireAuthenticationProps) => {
    const { routeId } = props

    useEffect(() => {
      async function checkSession() {
        if (!Vault.getAccessToken()) {
          const redirectTo =
            window.location.href.includes('enterprise') && window.location.href.includes('management')
              ? window.location.pathname
              : null
          return AuthenticationControllerService.fetchAuthorizationToken(redirectTo)
        }

        if (routeId === 'root') {
          navigate('/top-fives')
        }
      }

      checkSession()
    }, [])

    return useMemo(
      () => (
        <React.Fragment>
          <Component {...props} />
          <AuthenticationMonitor />
        </React.Fragment>
      ),
      [props]
    )
  }
}

export default withRequireAuthentication
